/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IWineFinderForm contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum resultsDisplay {
    paginate = 'paginate',
    append = 'append'
}

export const enum showProductsConfiguration {
    showButton = 'showButton',
    hideProductsHideButton = 'hideProductsHideButton',
    showProductsHideButton = 'showProductsHideButton'
}

export interface IWineFinderFormConfig extends Msdyn365.IModuleConfig {
    perPage?: number;
    resultsDisplay?: resultsDisplay;
    singlePage?: boolean;
    brand?: string;
    title?: ITitleData;
    searchText?: Msdyn365.RichText;
    hideInternational?: boolean;
    searchRadius: number;
    showFilterButtons: boolean;
    showProductsConfiguration?: showProductsConfiguration;
    showChooseWineInput?: boolean;
    showAllProductsToggle?: boolean;
    showAllProductsLabel?: IShowAllProductsLabelData;
    showProductsLabel?: IShowProductsLabelData;
    placeholders?: IPlaceholdersData;
    defaultFilters?: IDefaultFiltersData;
    filterState?: IFilterStateData;
    wineFinderSubmit?: string;
    mapText?: string;
    hideNumbers?: boolean;
    USLabelText?: string;
    internationalLabelText?: string;
}

export interface IWineFinderFormResources {
    wineFinder__internationalTitle: string;
    wineFinder__internationalCountryLabel: string;
    wineFinder__domesticTitle: string;
    wineFinder__domesticSearchRadiusLabel: string;
    wineFinder__backToFind: string;
    wineFinder__noResults: string;
    wineFinder__searchAgain: string;
    wineFinder__showMoreButton: string;
    wineFinder__showProducts: string;
    wineFinder__hideProducts: string;
    wineFinder__internationalWebsiteLabel: string;
    wineFinder__retailFilterText: string;
    wineFinder__restaurantFilterText: string;
}

export const enum TitleTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface ITitleData {
    text: string;
    tag?: TitleTag;
}

export interface IShowAllProductsLabelData {
    hideAllProducts?: string;
    showAllProducts?: string;
}

export interface IShowProductsLabelData {
    hideProducts?: string;
    showProducts?: string;
}

export interface IPlaceholdersData {
    enablePlaceholders?: boolean;
    domesticSearch?: string;
}

export interface IDefaultFiltersData {
    retail?: boolean;
    restaurant?: boolean;
}

export interface IFilterStateData {
    retailActive?: boolean;
    restaurantActive?: boolean;
}

export interface IWineFinderFormProps<T> extends Msdyn365.IModule<T> {
    resources: IWineFinderFormResources;
    config: IWineFinderFormConfig;
}
